var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"world-background-green"},[_c('cards-roulette',{attrs:{"options":_vm.options,"type":'capital_program_types'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }